import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../../core/layout/Card';
import Async from '../../../../core/layout/Async';
import HorizontalBarChart from '../../../../core/chart/HorizontalBarChart';
import TooltipIcon from '../../../../core/layout/TooltipIcon';
import { last, get } from 'lodash';

export default function ErrorsPerGrammarChart(props) {
  const total = props.data.reduce((acc, item) => acc + item.total, 0);

  return (
    <Card
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 5 }}>Errors per Grammar</span>
          <TooltipIcon text="This chart shows the top ten grammars with the most errors among all the errors in the filtered tests." />
        </div>
      }
    >
      <Async fetching={props.isFetching}>
        <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {props.data.length > 0 ? (
            <HorizontalBarChart
              data={props.data.slice(0, 10).map((item) => item.total)}
              labels={props.data.slice(0, 10).map((item) => item.grammar)}
              colors="#006995"
              options={{
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                  display: false,
                },
                scales: {
                  xAxes: [
                    {
                      ticks: {
                        suggestedMin: 0,
                        suggestedMax: get(last(props.data), 'total', 0) + 3,
                      },
                    },
                  ],
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      const value = data.datasets[0].data[tooltipItem.index];
                      return `${data.labels[tooltipItem.index]}: ${((value / total) * 100).toFixed(
                        1
                      )}% - ${value} of ${total} errors`;
                    },
                  },
                },
              }}
            />
          ) : (
            <span>No errors found.</span>
          )}
        </div>
      </Async>
    </Card>
  );
}

ErrorsPerGrammarChart.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
};

ErrorsPerGrammarChart.defaultProps = {
  isFetching: false,
};
